<template>
  <div class="app-container">
    <div class="title-row"><span class="title">{{ this.$route.meta.title }}</span></div>
    <el-form @submit.native.prevent :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="分类名" prop="categoryName">
        <el-input v-model="queryParams.categoryName" placeholder="请输入分类名" clearable @keyup.enter.native="handleQuery"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"  icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格操作 -->
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button v-hasPermi="['article:category:add']" type="primary" plain size="mini" icon="el-icon-plus" @click="openModel(null)">新增</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button v-hasPermi="['article:category:remove']" type="danger" plain size="mini" icon="el-icon-delete" :disabled="multiple" @click="deleteCategory">批量删除</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList" ></right-toolbar>
    </el-row>
    <!-- 表格展示 -->
    <el-table :data="categoryList" @selection-change="selectionChange" v-loading="loading" >
      <!-- 表格列 -->
      <el-table-column type="selection" width="55" />
      <!-- 分类名 -->
      <el-table-column prop="categoryName" label="分类名" align="center" />
      <!-- 分类创建时间 -->
      <el-table-column prop="createTime" label="创建时间" align="center" width="200">
        <template slot-scope="scope">
          <i class="el-icon-time" />
          <span class="ml4">{{ scope.row.createTime | dateTime }} </span>
        </template>
      </el-table-column>
      <!-- 列操作 -->
      <el-table-column label="操作" width="160" align="center">
        <template slot-scope="scope">
          <el-button v-hasPermi="['article:category:edit']" size="mini" type="text" icon="el-icon-edit" @click="openModel(scope.row)">编辑</el-button>
          <el-button v-hasPermi="['article:category:remove']" size="mini" type="text" icon="el-icon-delete" @click="deleteCategory(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.current"
      :limit.sync="queryParams.size"
      @pagination="getList"
    />
    <!-- 添加编辑对话框 -->
    <el-dialog :title="categoryTitle" :visible.sync="open" width="400px" :close-on-click-modal="false" >
      <el-form ref="categoryForm" label-width="90px" :model="categoryForm" :rules="categoryRules">
        <el-form-item label="分类名称" prop="categoryName">
          <el-input v-model="categoryForm.categoryName"  />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="addOrEditCategory">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {getCategoriesList, addCategories, updateCategories, removeCategories} from "@/api/article/category";
export default {
  created() {
    this.getList();
  },
  data: function() {
    return {
      loading: true,
      open: false,
      showSearch: true,
      keywords: null,
      // 非多个禁用
      multiple: true,
      categoryIds: [],
      categoryList: [],
      categoryNameList: [],
      categoryTitle: "",
      categoryForm: {
        categoryId: null,
        categoryName: ""
      },
      categoryRules: {
        categoryName: [
          { required: true, message: "请输入分类名称", trigger: "blur" }
        ]
      },
      queryParams: {
        current: 1,
        size: 10,
        categoryName: null
      },
      total: 0
    };
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.current = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    selectionChange(selection) {
      this.categoryIds = selection.map(item => item.categoryId);
      this.categoryNameList = selection.map(item => item.categoryName);
      this.multiple = !selection.length;
    },
    deleteCategory(row) {
      let ids = this.categoryIds;
      let names = this.categoryNameList;
      if (row.categoryId) {
        ids = [row.categoryId];
        names = [row.categoryName];
      }
      this.$modal.confirm('是否确认删除分类名称为"' + names + '"的数据项？').then(function() {
          return removeCategories(ids);
        }).then(() => {
          this.getList();
        }).catch(() => {});
    },
    getList() {
      getCategoriesList(this.queryParams).then(res => {
        this.categoryList = res.rows;
        this.total = res.total;
        this.loading = false;
      });
    },
    reset() {
      this.categoryForm = {
        categoryId: null,
        categoryName: ""
      }
      this.resetForm('categoryForm')
    },
    cancel(){
      this.open = false;
      this.reset()
    },
    openModel(category) {
      this.reset();
      if (category != null) {
        this.categoryForm = JSON.parse(JSON.stringify(category));
        this.categoryTitle = "修改分类";
      } else {
        this.categoryTitle = "添加分类";
      }
      this.open = true;
    },
    addOrEditCategory() {
      this.$refs["categoryForm"].validate(valid => {
        if (valid) {
          if (this.categoryForm.categoryId != null) {
            updateCategories(this.categoryForm).then(res => {
              this.$modal.msgSuccess("修改成功");
              this.getList();
              this.open = false;
            });
          } else {
            addCategories(this.categoryForm).then(res => {
              this.$modal.msgSuccess("新增成功");
              this.getList();
              this.open = false;
            });
          }
        }
      });
    }
  }
};
</script>
